<script setup lang="ts">
import { computed } from 'vue';

export type FieldSize = 'xs' | 'sm' | 'md';

export interface Props {
  size?: FieldSize;
}
const props = withDefaults(defineProps<Props>(), {
  size: 'md',
});

const sizeClass = computed(() => 'size-' + props.size);
</script>

<template>
  <v-radio
    :class="[$style.kRadioField, $style[sizeClass]]"
    data-testid="kRadioField"
    density="compact"
  ></v-radio>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.kRadioField {
  min-height: var(--v-input-control-height);

  :global {
    .v-selection-control__wrapper {
    }
      .v-selection-control__input > .v-icon {
        opacity: 1;
        color: colors.$color-brand-800;
      }
    .v-label {
      opacity: 1;
      color: inherit;
    }
  }
}

.size-xs {
  --v-input-control-height: #{variables.$btn-xs-height};
  --v-selection-control-size: #{variables.$btn-xs-height - 12};

  :global {
    .v-selection-control__wrapper {
      margin-left: -4px;
    }
      .v-selection-control__input > .v-icon {
        font-size: 16px;
      }
    .v-label {
      font-size: variables.$btn-xs-font-size;
      margin-left: 1px;
    }
  }
}

.size-sm {
  --v-input-control-height: #{variables.$btn-sm-height};
  --v-selection-control-size: #{variables.$btn-sm-height - 12};

  :global {
    .v-selection-control__wrapper {
      margin-left: -4px;
    }
      .v-selection-control__input > .v-icon {
        font-size: 20px;
      }
    .v-label {
      font-size: variables.$btn-sm-font-size;
      margin-left: 1px;
    }
  }
}

.size-md {
  --v-input-control-height: #{variables.$btn-md-height};
  --v-selection-control-size: #{variables.$btn-md-height - 12};

  :global {
    .v-selection-control__wrapper {
      margin-left: -5px;
    }
      .v-selection-control__input > .v-icon {
        font-size: 24px;
      }
    .v-label {
      font-size: variables.$btn-md-font-size;
      margin-left: 1px;
    }
  }
}
</style>
